
import _some from 'lodash/some'
import _filter from 'lodash/filter'

export default {
  name: 'SecuritiesBonds',
  fetchOnServer: false,
  data() {
    return {
      filterKeyword: '',
      filterExchange: [],
      showGovtBonds: false,
      showCommercialBonds: false,
      showMaturedBonds: false,
      securities: [],
    }
  },
  async fetch() {
    try {
      const rawResponse = await fetch(`${this.$config.apiBaseUrl}/data`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `Command=FreshSecuritiesLists&Language=${this.$i18n.locale}&securitytype=bonds`,
      })
      this.securities = await rawResponse.json()
    } catch (error) {
      // console.log(error)
    }
  },
  computed: {
    filteredSecurities() {
      var result = this.securities.filter((security) => {
        if (security.FullName != null) {
          return security.FullName.toLowerCase().includes(this.filterKeyword.toLowerCase()) && security.Active
        }
      })
      if (this.securities.length) {
        result = result.filter((security) => {
          return security.IsMatured == this.showMaturedBonds
        })
      }

      if (this.filterExchange.length) {
        result = result.filter((security) => {
          return this.filterExchange.includes(security.Exchange)
        })
      }

      if (this.showMaturedBonds) {
        result = result.filter((security) => {
          return security.IsMatured
        })
      }

      if (this.showCommercialBonds || this.showGovtBonds) {
        result = result.filter((security) => {
          return Object.values(security).includes('Government Bonds') == this.showGovtBonds || Object.values(security).includes('Commercial Bonds') == this.showCommercialBonds
        })
      }

      return result
    },
  },
  methods: {
    setKeyword(keyword) {
      this.filterKeyword = keyword
    },
    getExchanges(exchanges) {
      this.filterExchange = exchanges
    },
  },
}
